import React from "react";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import HomeIcon from "@mui/icons-material/Home";
import Tooltip from "@mui/material/Tooltip";
import TextsmsIcon from "@mui/icons-material/Textsms";
import ClearIcon from "@mui/icons-material/Clear";
import { STATUS_CODE_MAP } from "../../../constants/provider/constant";

const ActionsCell = ({
  visitType,
  dndStatus,
  isHNI,
  status,
  row,
  pageName,
  handleClickOpencustomerAttendance,
  handleClickOpenShowCommunicationHistory,
  // handleClickOpenConfirmAppointment,
  // handleClickOpendocumentSubmission
}) => {
  const { rowData } = row;
  const { currentStatusId } = rowData;
  const isCustomerDndActive = (data) => {
    const negateArr = ["False", "false", "FALSE"];
    return data && !negateArr.includes(data);
  };
  return (
    <div className="text-xs flex justify-end justify-items-end al-itm-bs">
      <div className="text-red-500">
        {isCustomerDndActive(dndStatus) ? (
          <DoNotDisturbIcon className="text-red-500" />
        ) : (
          <></>
        )}
      </div>
      <div className="text-gray-500">
        {visitType === "Home_Visit" ? <HomeIcon /> : ""}
      </div>
      <div>
        {isHNI ? (
          <div className="bg-yellow-100 rounded text-xs px-2 py-1"> HNI </div>
        ) : (
          ""
        )}
      </div>
      <div>
        <div className="text-gray-500 mx-1 text-yellow-700 cursor-pointer">
          <Tooltip title="Communication History" placement="bottom-end">
            <TextsmsIcon onClick={(event) => handleClickOpenShowCommunicationHistory(event, row.rowData)} />
          </Tooltip>
        </div>
      </div>
      {/* <div className="flex">
        {pageName?.length && pageName.includes(status) ? (
          <div className="text-gray-500 mx-1 text-yellow-700 cursor-pointer">
            <Tooltip title="Communication History" placement="bottom-end">
              <TextsmsIcon
                onClick={(event) =>
                  handleClickOpenShowCommunicationHistory(event, rowData)
                }
              />
            </Tooltip>
          </div>
        ) : ![
            STATUS_CODE_MAP["Not Attended"],
            STATUS_CODE_MAP["Rejected"],
          ].includes(currentStatusId) ? (
          <>
            <div
              className="border border-green-400  hover:bg-green-600 hover:border-green-600 hover:text-gray-100 text-gray-900 font-semibold text-xxs text-center rounded-md py-1 px-3 text-xs cursor-pointer ml-2 mb-2"
              onClick={(event) =>
                handleClickOpenConfirmAppointment(event, rowData, "confirm")
              }
            >
              Confirm
            </div>
            <div
              className="border border-red-400  hover:bg-red-600 hover:border-red-600 hover:text-gray-100 text-gray-900 font-semibold text-xxs  text-center rounded-md py-1 px-3 text-xs cursor-pointer ml-2 mb-2"
              onClick={(event) =>
                handleClickOpenConfirmAppointment(event, rowData, "reject")
              }
            >
              Reject
            </div>
          </>
        ) : (
          <></>
        )}
      </div> */}
      {/* <div>
        {['pending','settled'].includes(status) ?
          <Tooltip title={status==="pending"?"Submit Reports":"Submit Bills"} placement="bottom-end">
            <AttachFileIcon className="attachements" onClick={(event) => handleClickOpendocumentSubmission(event, row.rowData)}></AttachFileIcon>
          </Tooltip>
          : ''}
      </div> */}

      {/* <div>
        {pageName?.length && pageName.includes(status) &&
        currentStatusId === STATUS_CODE_MAP["Customer awaited at DC"] ? (
          <Tooltip title="Mark Attended" placement="bottom">
            <div
              className="border border-green-400  hover:bg-green-600 hover:border-green-600 hover:text-gray-100 text-gray-900 text-center px-1 rounded-md cursor-pointer ml-1"
              onClick={(event) =>
                handleClickOpencustomerAttendance(event, rowData, true)
              }
            >
              <CheckIcon style={{ fontSize: "20px" }}></CheckIcon>
            </div>
          </Tooltip>
        ) : (
          <></>
        )}
      </div> */}
      <div>
        {pageName?.length && pageName.includes(status) &&
        currentStatusId === STATUS_CODE_MAP["Customer awaited at DC"] ? (
          <Tooltip title="Mark Not Attended" placement="bottom">
            <div
              className="border border-red-400  hover:bg-red-600  hover:border-red-600  hover:text-gray-100 text-gray-900 text-center px-1 rounded-md cursor-pointer ml-1"
              onClick={(event) =>
                handleClickOpencustomerAttendance(event, rowData, false)
              }
            >
              <ClearIcon style={{ fontSize: "20px" }}></ClearIcon>
            </div>
          </Tooltip>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default ActionsCell;
